import React from 'react';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import Documents from 'components/common/element-data/parts/Documents';
import { ElementMetadataSectionName, IElementDataSectionDocuments } from 'components/common/element-data/types';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function DocumentsSection(props: IElementDataSectionDocuments) {
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'documents';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection order={sectionMetadataOrder}>
            <Documents {...element} settings={settings} />
        </ElementDataSection>
    );
}
